import type { EntityRegistry } from '@sites/entity-migrator';
import { isRecord } from '@sites/entity-migrator';

import type { DefaultLine } from './schemas';
import { DefaultLineEntitySchema } from './schemas';

export const lineRegistry: EntityRegistry<DefaultLine> = {
    name: 'line',
    getEntitySchema: (entity: unknown) => {
        if (!isRecord(entity)) return null;

        const { entityType, entitySubType, version, name } = entity;

        if (entityType === 'widget:line' && entitySubType === 'default') return DefaultLineEntitySchema;
        // Pre-versioning lines carry no version; the widget name is the only proof of kind.
        if (version === undefined && name === 'line') return DefaultLineEntitySchema;

        return null;
    },
};
